import React from 'react';
import Translate from "~/Components/ContentTranslate/Translate";
import TextTranslate from '../../Components/TextTranslate/TextTranslate';

import './racedaytickets.scss';

export default function RaceDayTickets({data}) {

	if(!data) {
		return <></>;
	}

	return (
		<div className="racedaytickets text-left">
			<div className="container">
				<div className="row">
					<div className="col-lg-6 col-12 pl-0 pr-0 pr-lg-3">
						<h4 className="text-headline"><TextTranslate name="event-racedaytickets" fallbakc="Race Day Tickets"/></h4>
						<p className="pre-line">{<Translate model={data} field="description" />}</p>
					</div>
					<div className="useful-info col-lg-6 col-12 pr-0">
						<h4 className="text-headline"><TextTranslate name="word-useful-information" fallback="Useful Information"/></h4>

                        <p className="pre-line">{<Translate model={data} field="info" />}</p>

                        {false && <ul>
							<li><p>All tickets are valid for 1-day (Saturday/ race day) and are to be used by one person only.</p></li>
							<li><p>Accreditation must always be worn by guests and visible inside the circuit.</p></li>
							<li><p>Please note that tickets will not be sent prior to the event and collection will be arranged with you nearer the time.</p></li>
							<li><p>Schedules will be provided for the race weekend once all track activity has been confirmed.</p></li>
						</ul>}
					</div>
				</div>
			</div>
		</div>
	)
}
